import { render, staticRenderFns } from "./ebarimtInfo.vue?vue&type=template&id=e8cd7a10&scoped=true&"
import script from "./ebarimtInfo.vue?vue&type=script&lang=js&"
export * from "./ebarimtInfo.vue?vue&type=script&lang=js&"
import style0 from "./ebarimtInfo.vue?vue&type=style&index=0&id=e8cd7a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8cd7a10",
  null
  
)

export default component.exports